import { ApplicationElement, html } from '../application_element/element.js';

/**
 * Used as Call-to-action panel with link and descriptions
 *
 * @prop name - Title
 * @prop icon - Name of the icon class ( optional )
 * @prop short - Additional info display as short text ( optional )
 * @prop long - Additional info display as long text ( optional )
 * @prop link - Link to the invite
 * @prop linkText - Link text
 */
export default class Panel extends ApplicationElement {
  static properties = {
    name: { type: String },
    icon: { type: String },
    short: { type: String },
    long: { type: String },
    link: { type: String },
    linkText: { type: String },
  };

  createRenderRoot() {
    return this;
  }

  renderTitle() {
    return html`
      <h3 class="panel-box-title">
        ${this.icon ? html`<ef-icon name=${this.icon}></ef-icon>` : ''}
        <span>${this.name}</span>
      </h3>
    `;
  }

  renderBody() {
    return html`
      ${this.short
        ? html`
            <div class="panel-box-short">
              <p>${this.short}</p>
            </div>
          `
        : ''}
      ${this.long
        ? html`
            <div class="panel-box-long">
              <p>${this.long}</p>
              ${this.link
                ? html`
                    <a
                      data-turbolinks-action="advance"
                      class="btn btn-v1 t1"
                      href=${this.link}
                      >${this.linkText}</a
                    >
                  `
                : ''}
            </div>
          `
        : ''}
    `;
  }

  render() {
    return html`
      <div class="panel-box panel-box-default">
        ${this.renderTitle()} ${this.renderBody()}
      </div>
    `;
  }
}

customElements.get('ef-panel') || customElements.define('ef-panel', Panel);
